import { Modal as AntModal } from 'antd'
import styled from 'styled-components'

const Modal = styled(AntModal)`
	.ant-result {
		min-height: 300px;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
`

export default { Modal }
